import Swiper, { Pagination, Manipulation } from "swiper";
import { initIntersectionObserver } from "@plugins";

const articlesSwipers = document.querySelectorAll(".js-articles-swiper-init");

if (window.mobileMedia && articlesSwipers) {
    articlesSwipers.forEach((slider) => {
        initIntersectionObserver(slider, articlesSwiperInit);
    });
}

function articlesSwiperInit(slider) {
    const swiperContainer = slider.querySelector(".js-articles-swiper-container");
    const swiperControls = slider.querySelector(".js-articles-swiper-controls");
    const swiperPagination = swiperControls?.querySelector(".swiper-pagination");

    if (swiperContainer) {
        const swiper = new Swiper(swiperContainer, {
            modules: [Pagination, Manipulation],
            slidesPerView: 1.7,
            spaceBetween: 17,
            pagination: {
                el: swiperPagination,
                type: "progressbar",
            },
            observer: true,
            watchOverflow: true,
            breakpoints: {
                406: {
                    slidesPerView: 2,
                },
                567: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 28,
                },
            },
        });

        const showAllLink = slider.querySelector(".js-articles-link-more");

        if (showAllLink) {
            showAllLink.classList.add("swiper-slide");
            swiper.appendSlide(showAllLink);
        }
    }
}
